/**
 * The PDP's sticky mobile add-to-cart bar opens a "quick-buy" popup after the
 * item is already added (see sections/hnf-product.liquid, [data-hnf-quickbuy]).
 * That popup offers two actions: a real "Buy Now" checkout button, and a
 * second button that just dismisses the popup and opens the cart. That
 * second button's Liquid markup hardcodes the label "Add to Cart" — but the
 * item is already in the cart at that point, so clicking it doesn't add
 * anything. Relabeling it here (rather than re-uploading the full PDP
 * section file) keeps this fix small and isolated to the one string.
 */
document.addEventListener('DOMContentLoaded', function () {
  var viewCartBtn = document.querySelector('[data-hnf-quickbuy-cart]');
  if (viewCartBtn) viewCartBtn.textContent = 'View Cart';
});
